import AnalyticsGoogleCategories from './google/categories/Categories'
import AnalyticsGoogleActions from './google/actions/Actions'

const Modules = {
    AnalyticsGoogleCategories,
    AnalyticsGoogleActions,
}

export default Modules
